import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

// SAFETY: Clean up invalid localStorage data that causes crashes
try {
    const savedUser = localStorage.getItem('user');
    if (savedUser === 'undefined') {
        console.warn('Cleaning up invalid user data from localStorage');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    }
} catch (e) {
    console.error('Error cleaning up localStorage:', e);
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </React.StrictMode>
);
